import styled from "@emotion/styled";
import { LdLabel } from "@liquid/react";

const StyledLdLabel = styled(LdLabel)<{ width?: number | string}>`
  width: ${({ width }) => width};
`;

const StyledLdLabelSlider = styled(LdLabel)<{ mLeft?: string }>`
  margin-left: ${({ mLeft }) => (mLeft === "flexible" ? "32%" : "21%")};
`;

const StyledLabel = styled.span`
  &[data-required="true"] {
    :after {
      content: " *";
    }
  }
`;

const StyledDiv = styled.span`
  color: #5a5959;
  background: #f2f2f2;
  display: flex;
  height: 100%;
  width: 50%;
  margin: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #ededed;
`;

export { StyledLabel, StyledLdLabel, StyledLdLabelSlider, StyledDiv };
